"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _index = require("./index");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var payload = function payload(values) {
  if ((0, _index.isCustom)(values.type)) {
    return {
      type: values.type,
      output: values.reportHeader,
      label: values.label,
      appendInput: true
    };
  }
  var input = values.type === _index.IF_THEN ? ifThenInput(values.ifThen.conditions) : values.variables;
  if (values.type === _index.EQUATION) {
    return {
      valueType: 'double',
      type: values.type,
      input: input,
      output: values.reportHeader,
      label: values.label,
      equation: values.equation,
      args: {
        n_input: values.variables.length
      }
    };
  }
  var args = values.type === _index.IF_THEN ? values.ifThen : _objectSpread(_objectSpread({
    n_input: values.calculateCondition === 'all' ? values.variables.length : values.minimumAnswers
  }, typeof values.minimum === 'number' ? {
    minimum: values.minimum
  } : null), typeof values.maximum === 'number' ? {
    maximum: values.maximum
  } : null);
  return {
    valueType: 'double',
    type: values.type,
    input: input,
    output: values.reportHeader,
    label: values.label,
    args: args
  };
};
var ifThenInput = function ifThenInput(conditions) {
  var result = {};
  conditions.forEach(function (condition) {
    return _getConditionInput(condition.condition, result);
  });
  return Object.values(result);
};
var _getConditionInput = function getConditionInput(condition, result) {
  return condition.conditions.forEach(function (c) {
    if ('dataConnector' in c) {
      result[c.dataConnector.id] = c.dataConnector.id;
    }
    if ('conditions' in c) {
      _getConditionInput(c, result);
    }
  });
};
var _default = exports["default"] = payload;